/**
 * Actions list (/events/actions) — verbs the event catalog is built from.
 */
import { Zap } from 'lucide-react'
import { MasterTypeList, type MasterTypeConfig } from './MasterTypeList'

const actionConfig: MasterTypeConfig = {
  title: 'Actions',
  singular: 'action',
  icon: Zap,
  listEndpoint: 'getEventActions',
  upsertEndpoint: 'upsertEventAction',
  archiveEndpoint: 'archiveEventAction',
  dataKey: 'actions',
  numberKey: 'actionNumber',
  nameKey: 'actionName',
  descKey: 'actionDescription',
  nameRegex: /^[a-z][a-zA-Z0-9]*$/,
  nameHint: 'camelCase past-tense verb, e.g. added, invited, statusChanged',
  nameErrorHint: 'Use camelCase — start with a lowercase letter, letters and numbers only, no spaces (e.g. statusChanged)',
  namePlaceholder: 'provisioned',
}

export function ActionList() {
  return <MasterTypeList config={actionConfig} />
}
